/** Dispatched when a Material select/autocomplete panel opens inside a trapped dialog. */
export const MOT_OVERLAY_PANEL_OPENED = 'mot-overlay-panel-opened';

/** Dispatched when that panel closes (resume dialog focus trap). */
export const MOT_OVERLAY_PANEL_CLOSED = 'mot-overlay-panel-closed';
